import { Dispatch } from "redux";
import { setLoading } from "./global";
import { showMessage } from "utilities/helper";
import CatalogService from "service/Catalog";
import { CatalogPayloadTypes } from "utilities/types/Catalog";
import { CatalogDescriptionPayloadTypes } from "utilities/types/CatalogDescription";

export const getAllCatalogs =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
    filterTenant: number = 3
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_CATALOG_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_CATALOG",
      searchValue: search,
    });

    try {
      const data = await CatalogService.getAllCatalogs(
        page,
        search,
        limit,
        filterTenant
      );

      dispatch(setLoading(false));
      dispatch({
        type: "SET_CATALOG",
        value: data.catalogs,
      });
      dispatch({
        type: "SET_CATALOG_PAGE",
        totalPage: !!data.catalogs.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.catalogs.length ? data.total_data : 1,
      });
      dispatch({
        type: "SET_CATALOG_FILTER_PAGE",
        filterTenantPage: filterTenant,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const getCatalogById =
  (catalogId: any) => async (dispatch: Dispatch) => {
    dispatch({ type: "SET_CATALOG_DETAIL_LOADING", value: true });

    try {
      const data = await CatalogService.getCatalogById(catalogId);
      dispatch({ type: "SET_CATALOG_DETAIL_LOADING", value: false });

      dispatch({
        type: "SET_CATALOG_DETAIL",
        value: data.catalog,
      });
    } catch (err: any) {
      dispatch({ type: "SET_CATALOG_DETAIL_LOADING", value: false });
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const storeCatalog =
  (form: CatalogPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await CatalogService.storeCatalog(payload);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().catalogReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllCatalogs(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateCatalog =
  (
    catalogId: string,
    form: CatalogPayloadTypes,
    handleCloseModal: () => void
  ) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await CatalogService.updateCatalog(catalogId, payload);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().catalogReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(
        getAllCatalogs(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const deleteCatalog =
  (catalogId: string, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    try {
      const data = await CatalogService.deleteCatalog(catalogId);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().catalogReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_CONFIRMATION", value: false });

      dispatch(
        getAllCatalogs(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateCatalogDescription =
  (form: CatalogDescriptionPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await CatalogService.updateCatalogDescription(payload);
      const { currentPage, searchValue, limitPage, filterTenantPage } =
        getState().catalogReducer;

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_DESCRIPTION", value: false });

      dispatch(
        getAllCatalogs(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage
        ) as any
      );

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };
